import { API_MAP, agent } from 'helpers';

class DashboardService {
  //invoice_order=created_at
  static lastSales(dateUsed?: any) {
    let parametro = '';
    if (dateUsed) {
      parametro += 'invoice_order=' + dateUsed;
    }

    return agent.get(API_MAP.lastSales + '?' + parametro);
  }

  static dashValues() {
    return agent.get(API_MAP.dashValues);
  }

  static lastLeads() {
    return agent.get(API_MAP.lastLeads);
  }

  static dashProducts(lastPeriodDays?: any, type?: any) {
    let parametroDays = '';
    let parametroType = '';
    if (lastPeriodDays) {
      parametroDays = lastPeriodDays;
    }
    if (type) {
      parametroType = type;
    }
    return agent.get(API_MAP.dashProducts + '?last_period_days=' + parametroDays + '&type=' + parametroType);
  }

  static listNewzz(quantity?: any) {
    let parametro = '';
    if (quantity) {
      parametro += 'per_page=' + quantity;
    }
    return agent.get(API_MAP.listNewzz + '?' + parametro);
  }

  static clickNewzz(id: any) {
    return agent.post(API_MAP.clickNewzz.replace('{id}', id), {});
  }

  static indications() {
    return agent.get(API_MAP.indications);
  }

  static bestsellers(days: any) {
    let api = API_MAP.bestsellers;
    if (days) {
      api = `${api}?last_period_days=` + days;
    }
    return agent.get(api);
  }

  static periodSalesGain(startDate?: any, endDate?: any) {
    let api = API_MAP.periodsalesgains;
    if (startDate && endDate) {
      api = `${api}?start_date=${startDate}&end_date=${endDate}`;
    }
    return agent.get(api);
  }

  static lastGain(startDate?: any, endDate?: any) {
    let api = API_MAP.lastgains;
    if (startDate && endDate) {
      api = `${api}?start_date=${startDate}&end_date=${endDate}`;
    }
    return agent.get(api);
  }
}

export default DashboardService;
